var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"pointer",class:_vm.button.icon,attrs:{"data-toggle":"tooltip","title":_vm.button.buttonText},on:{"click":_vm.sendRequest}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-841f365c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/Participants/SaveParticipantProfileToggleButton.vue
// module id = 738
// module chunks = 0 1